










import { Component, Vue, Mixins, Watch } from 'vue-property-decorator'
import OrderDetail from './orderDetail.vue'
@Component({
	name: 'PartnerOrderDetail',
	components: {
		OrderDetail,
	},
})
export default class PartnerOrderDetail extends Vue {
	private get canChecked() {
		return this.$route.params.canChecked
	}
	private get orderId() {
		return this.$route.params.orderId
	}
	private get dispatchId() {
		return this.$route.params.dispatchId
	}
	// private created() {
	// 	console.log(
	// 		'orderId1:',
	// 		this.$route.params.orderId,
	// 		'dispatchId1:',
	// 		this.$route.params.dispatchId,
	// 		'CanChecked1:',
	// 		this.$route.params.canChecked
	// 	)
	// }
}
